type RegexItem = {
  exp: RegExp,
  message: string,
}

export const personNameRegex: RegexItem = {
  exp: /^[a-zA-Z\u00C0-\u017F]?[a-zA-Z\u00C0-\u017F\s\\-]*[a-zA-Z\u00C0-\u017F]$/,
  message: ' can only consist of letters; or letters with a hyphen or a space in between.',
};

const nameRegex: RegexItem = {
  exp: /^[\p{L}0-9_/, .'\-?!]*$/u,
  message: ' can only have letters, digits, spaces, commas, underscore, slash, dot and hyphen characters.',
};

export const emailRegex: RegexItem = {
  exp: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?:\.[a-zA-Z0-9-]+)*$/,
  message: 'Email address is invalid',
};

export const externalIdRegex: RegexItem = {
  exp: /^[A-Za-z0-9][A-Za-z0-9-|A-Za-z0-9.]*[A-Za-z0-9]$/,
  message: 'External ID can only have letters and digits with hyphen(s) or dots in between',
};

export const integerRegex: RegexItem = {
  exp: /^[0-9]*$/,
  message: ' can only be an integer',
};

export default nameRegex;
